import { RIGHT_ALIGNED } from '../constants/WidgetLocations';
import { useDisplayMode } from '../../contexts/DisplayModeContext';
import WidgetHeader from './WidgetHeader';
import VisitorWidgetStyleWrapper from '../../presentation-components/VisitorWidgetStyleWrapper';
import styled from 'styled-components';
import { THREAD_VIEW } from '../constants/views';
import { getBrandStyle } from '../util/color';
import KBNavigation from './KBNavigation';
import { WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { KBSearchProvider } from '../../knowledge-base/context/KBSearchProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WidgetBodyDiv = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDiv"
})(["display:flex;flex-direction:column;height:100%;background-color:", ";overflow:auto;border-start-end-radius:10px;"], WHITE);
export const WidgetBodyDivWrapper = styled.div.withConfig({
  displayName: "VisitorWidget__WidgetBodyDivWrapper"
})(["flex:1;min-height:0;display:flex;flex-direction:column;", ";"], ({
  $background
}) => getBrandStyle($background));
const VisitorWidget = ({
  backButtonDisabled,
  browserWindowHeight,
  browserWindowWidth,
  chatHeadingConfig,
  chatHeadingResponders,
  children,
  closeWidget,
  coloring,
  createNewThread,
  customHeaderText = null,
  endChat,
  inline = false,
  isThreadAssigned = false,
  isThreadClosed = false,
  isThreadPersisted = false,
  isThreadStarted = false,
  kbArticleDeepLink,
  restorePreviousViewFromKBArticle,
  mobile = false,
  navigateToKnowledgeBaseArticle,
  navigateBack,
  officeHoursMessage,
  setWidgetSize,
  showAvailabilityMessage,
  showBackButton,
  size = 'default',
  style,
  toggleWidgetSizeForKBArticle,
  typicalResponseTimeMessage,
  unseenThreadsCountExcludingCurrentThread,
  view = THREAD_VIEW,
  viewKBArticleExpanded,
  widgetLocation = RIGHT_ALIGNED,
  widgetSize,
  updateView,
  kbNavigationEnabled,
  isUngatedForCloseThread = false
}) => {
  const {
    onToggleDisplayMode,
    showDisplayModeToggle,
    widgetDisplayMode
  } = useDisplayMode();
  return /*#__PURE__*/_jsx(VisitorWidgetStyleWrapper, {
    browserWindowHeight: browserWindowHeight,
    browserWindowWidth: browserWindowWidth,
    inline: inline,
    size: size,
    style: style,
    mobile: mobile,
    widgetLocation: widgetLocation,
    widgetSize: widgetSize,
    children: /*#__PURE__*/_jsxs(KBSearchProvider, {
      children: [/*#__PURE__*/_jsx(WidgetHeader, {
        backButtonDisabled: backButtonDisabled,
        browserWindowHeight: browserWindowHeight,
        chatHeadingConfig: chatHeadingConfig,
        coloring: coloring,
        chatHeadingResponders: chatHeadingResponders,
        createNewThread: createNewThread,
        customHeaderText: customHeaderText,
        inline: inline,
        isThreadAssigned: isThreadAssigned,
        isThreadClosed: isThreadClosed,
        isThreadPersisted: isThreadPersisted,
        isThreadStarted: isThreadStarted,
        kbArticleDeepLink: kbArticleDeepLink,
        restorePreviousViewFromKBArticle: restorePreviousViewFromKBArticle,
        mobile: mobile,
        navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
        navigateBack: navigateBack,
        officeHoursMessage: officeHoursMessage,
        onClose: closeWidget,
        onEndChat: endChat,
        toggleWidgetSizeForKBArticle: toggleWidgetSizeForKBArticle,
        setWidgetSize: setWidgetSize,
        showAvailabilityMessage: showAvailabilityMessage,
        showBackButton: showBackButton,
        typicalResponseTimeMessage: typicalResponseTimeMessage,
        unseenThreadsCountExcludingCurrentThread: unseenThreadsCountExcludingCurrentThread,
        view: view,
        viewKBArticleExpanded: viewKBArticleExpanded,
        isUngatedForCloseThread: isUngatedForCloseThread,
        onToggleDisplayMode: onToggleDisplayMode,
        showDisplayModeToggle: showDisplayModeToggle,
        widgetDisplayMode: widgetDisplayMode
      }), /*#__PURE__*/_jsx(WidgetBodyDivWrapper, {
        $background: coloring.accentColor,
        kbNavigationEnabled: kbNavigationEnabled,
        children: /*#__PURE__*/_jsx(WidgetBodyDiv, {
          children: children
        })
      }), kbNavigationEnabled && /*#__PURE__*/_jsx(KBNavigation, {
        coloring: coloring,
        updateView: updateView,
        view: view
      })]
    })
  });
};
VisitorWidget.displayName = 'VisitorWidget';
export default VisitorWidget;